import { lazy } from 'react';
import withSuspense from '../../../../helpers/withSuspense.jsx';
import InputSkeleton from '../../../../skeleton_loaders/common/InputSkeleton.jsx';

const DatasourceSection = withSuspense(lazy(() => import('./DataSourceSection.jsx')), <div style={{width: 180}}><InputSkeleton /></div>);

export default DatasourceSection;